'use client';

import { Footer, Header } from '@/components';
import { YotpoReferrals } from '@/components/common';
import useAuth from '@/context/AuthContext';
import {
  TypeFooter,
  TypeHeader,
  TypePage,
  TypeSubFooter,
} from '@/core/generated-types';
import { useNavigationEvent } from '@/hooks/useNavigationEvent';
import { useTrustedShopsScript } from '@/hooks/useTrustedShopsScript';
import { getLeiaDeviceId } from '@/utils/leiaClientSide';
import { identifyCurrentUser, pageEvent } from '@/utils/rudderstack';
import { trackGuestCustomer, trackLoggedInCustomer } from '@/utils/dataLayer';
import Head from 'next/head';
import React, { useEffect } from 'react';
import { NewRelicSnippet } from '../NewRelicSnippet/NewRelicSnippet';

interface LayoutInterface {
  children: React.ReactNode;
  page: TypePage;
  header: TypeHeader;
  footer: TypeFooter;
  footerLegal: TypeSubFooter;
}

const Layout = ({ children, header, footer, footerLegal }: LayoutInterface) => {
  const { user, authLoading } = useAuth();
  const leia = getLeiaDeviceId();

  useEffect(() => {
    if (!authLoading) {
      if (user && user.attributes) {
        // Idenitfy user in rudderstack if the user is logged in
        identifyCurrentUser(user);
        trackLoggedInCustomer(user, leia);
      } else {
        trackGuestCustomer(leia);
      }
      pageEvent();
    }
  }, [authLoading, user, user?.attributes, leia]);

  useNavigationEvent(() => {
    pageEvent();
  });

  useTrustedShopsScript();

  return (
    <>
      <Head>
        <NewRelicSnippet />
        <meta
          name="viewport"
          content="width=device-width, height=device-height,initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
      </Head>
      <Header header={header} />
      <YotpoReferrals />

      <main data-testid="le-main" id="main-layout">
        {children}
      </main>
      <Footer footer={footer} footerLegal={footerLegal} />
    </>
  );
};

export default Layout;
